<template>
  <div id="home">
    <mNav></mNav>
    <mBanner></mBanner>
    <div class="menu">
      <a href="javascript:void(0);" @click="show = 'content'" :class="{ active:show=='content' }">
        集团介绍
      </a>
      <a href="javascript:void(0);" @click="show = 'culture'" :class="{ active:show=='culture' }"> 企业文化 </a>
    </div>
    <transition name="out-in">
      <div class="content" v-if="show == 'content'">
        <div class="content-container">
          <div class="c-img">
            <img src="@/assets/imgs/b7.jpg" alt="company" />
          </div>
          <div class="content-title">企业介绍</div>
          <div class="content-text">
            洋宇集团以自营品牌为主，集皮鞋、皮具、儿童用品的设计
            、开发、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发设计，致力于打造引领时尚和科技的一流产品，在全球时尚中心如法国巴黎、意大利
            米兰设有时尚信息中心。公司在温州、上海、广州、成都分别设有研发机
            构。
          </div>
        </div>
      </div>
      <div class="culture" v-else :key="show">
        <div class="culture-container">
          <div class="culture-list">
            <div class="item" v-for="item in culture" :key="item.index">
              <div class="item-container">
                <div class="line1">
                  <div class="l1-text">{{item.title}}</div>
                  <div class="l1-num">{{ item.index }}</div>
                </div>
                <div class="line2">
                  {{item.content}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <mFooter></mFooter>
  </div>
</template>
    <script>
import mNav from "@/components/m/Nav";
import mBanner from "@/components/m/Banner";
import mFooter from "@/components/m/Footer";
export default {
  name: "mIndex",
  components: {
    mNav,
    mBanner,
    mFooter,
  },
  metaInfo: {
    title: "洋宇集团",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      show: "content",
      culture: [{
        'index':"01",
        "title":"诚信服务",
        "content":"承诺服务到用户满意为止"
      },{
        'index':"02",
        "title":"品质第一",
        "content":"把产品和质量作为我们的生命线，不断创新产品，坚守质量标准。"
      },{
        'index':"03",
        "title":"低碳节能",
        "content":"不断优化，节约资源，化繁为简，减少对环境的污染"
      },{
        'index':"04",
        "title":"追求卓越",
        "content":"对价值和品质的不断追求"
      },]
    };
  },
};
</script>
  <style scoped>
.menu {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 0.49rem;
  border-bottom: 0.01rem solid #f3f3f3;
}
.menu a {
  margin: 0 0.14rem;
  line-height: 0.49rem;
  font-size: 0.18rem;
  font-weight: 600;
  color: #999999;
}

.menu a.active {
  position: relative;
  color: #333;
}

.menu a.active::after {
  position: absolute;
  top: 0.48rem;
  left: 0.16rem;
  content: "";
  width: 0.4rem;
  height: 0.02rem;
  background-color: #d91414;
}

.content {
  width: 100%;
}

.content .content-container {
  padding: 18px 32px 26px 32px;
}

.content .c-img,
.content .c-img img {
  width: 100%;
}

.content .content-title {
  position: relative;
  margin-top: 0.22rem;
  font-size: 0.18rem;
  font-weight: bold;
  color: #000000;
  line-height: 0.15rem;
}

.content .content-title::after {
  position: absolute;
  top: 0.25rem;
  left: 0;
  content: "";
  width: 0.24rem;
  height: 0.02rem;
  background-color: #ff0000;
}

.content .content-text {
  margin-top: 0.24rem;
  font-size: 0.18rem;
  font-weight: 400;
  color: #333333;
  line-height: 0.24rem;
}

.culture {
  width: 100%;
}

.culture .culture-container {
  padding: 0.5rem 0.38rem;
}

.culture .culture-list {
  width: 100%;
}

.culture .culture-list .item {
  margin-top: 0.14rem;
  background-color: white;
  box-shadow: 0px 1px 16px 2px rgba(115, 115, 115, 0.18);
}

.culture .culture-list .item .item-container {
  padding: 0.2rem;
}

.culture .culture-list .item .line1 {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  height: 0.24rem;
  padding-bottom: 0.14rem;
  border-bottom: 0.01rem solid #cccccc;
}

.culture .culture-list .item .line1 .l1-text {
  font-size: 0.16rem;
  font-weight: 600;
  color: #333333;
}

.culture .culture-list .item .line1 .l1-num {
  color: #d91414;
  font-size: 0.24rem;
}

.culture .culture-list .item .line2 {
  padding-top: 0.17rem;

  font-size: 0.13rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.18rem;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(150px);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}
</style>


// WEBPACK FOOTER //
// src/page/m/Home.vue